export default __webpack_public_path__ + "static/media/flutter-r-bg.4cfd5454.png";